import { render, staticRenderFns } from "./DeveloperList.vue?vue&type=template&id=80a41c30"
import script from "./DeveloperList.vue?vue&type=script&lang=js"
export * from "./DeveloperList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports